<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <h4>Generate New Link</h4>
    <div class="well">
      <div v-if="errors && errors.length" class="alert alert-danger">
        <ul>
          <li v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="new-link-activation">Link activation date *</label>
            <input
              id="new-link-activation"
              type="datetime-local"
              class="form-control"
              @change="setDefaultExpiration"
              :max="newLink.expirationDateString"
              v-model="newLink.activationDateString"
              :disabled="true"
            />
          </div>

          <div class="form-group">
            <label for="new-link-expiration">Link expiration date *</label>
            <input
              id="new-link-expiration"
              type="datetime-local"
              class="form-control"
              :min="newLink.activationDateString"
              v-model="newLink.expirationDateString"
              :disabled="true"
            />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="new-link-total-capacity">Total Capacity</label>
            <input
              id="new-link-total-capacity"
              type="number"
              class="form-control"
              v-model="newLink.totalCapacity"
              :disabled="true"
            />
          </div>

          <div class="form-group">
            <label for="new-link-license-end">License end date</label>
            <input
              id="new-link-license-end"
              type="date"
              class="form-control"
              v-model="newLink.licenseEndDateString"
              :disabled="true"
            />
          </div>
        </div>
      </div>

      <p>
        <i>{{ timezoneMessage }}</i>
      </p>
      <div class="form-group">
        <label for="new-link-notes">Notes</label>
        <textarea
          v-model="newLink.notes"
          class="form-control"
          rows="4"
          placeholder="e.g. school names, bitly URL, etc."
          id="new-link-notes"
        />
      </div>
      <p v-if="usesExternalId" class="alert alert-warning">
        When using accounts created by Signup Links, the user will NOT be able to use Single Sign-On
        (SSO) until their district adds them to the list of approved users. Until then, they must
        sign in with email and password.
      </p>
      <button class="btn btn-primary" :disabled="loading" @click.prevent="generateLink">
        Generate new link
        <i class="fa fa-spinner fa-spin" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import {
  getLinkValidationErrors,
  defaultLicenseDateString,
  utcDateTimeStringFromLocalDateTimeString,
  dateTimeStringFromDateString,
  localDateTimeStringFromUTCdateTimeString,
  localDateTimeStringFromNow
} from './helpers'
export default {
  name: 'SignupLinkNew',
  data() {
    return {
      newLink: {
        activationDateString: localDateTimeStringFromNow(),
        expirationDateString: '',
        licenseStartDateString: '',
        licenseEndDateString: '',
        notes: '',
        totalCapacity: null
      },
      errors: [],
      loading: false
    }
  },
  props: {
    timezoneMessage: {
      type: String,
      required: true
    },
    domainUuid: {
      type: String,
      required: true,
      default: ''
    },
    usesExternalId: {
      type: Boolean,
      default: false
    },
    toolkitMaxUsers: {
      type: Number,
      default: null
    }
  },
  methods: {
    computeCapacityFromMaxUsers(maxUsers) {
      const n = Number(maxUsers)
      if (Number.isNaN(n) || !Number.isFinite(n) || n < 100) return 10
      return Math.floor(n * 0.15)
    },
    generateLink() {
      this.loading = true
      const errors = getLinkValidationErrors(this.newLink)
      this.errors = errors
      if (errors.length) {
        this.loading = false
        return
      }
      const {
        activationDateString,
        expirationDateString,
        totalCapacity,
        licenseEndDateString,
        notes
      } = this.newLink
      this.errors = []
      this.$angularWorld.adminApi
        .postSignupLink({
          domain_uuid: this.domainUuid,
          activation_date: utcDateTimeStringFromLocalDateTimeString(activationDateString),
          expiration_date: utcDateTimeStringFromLocalDateTimeString(expirationDateString),
          license_end_date: dateTimeStringFromDateString(licenseEndDateString),
          total_capacity: Number(totalCapacity),
          created_by: this.$angularWorld.auth.currentUser.uuid,
          notes
        })
        .then(
          signupLink => {
            this.$emit('updatedLink', signupLink)
            this.loading = false
          },
          error => {
            this.errors.push(error)
            this.loading = false
          }
        )
    },
    setDefaultExpiration() {
      const defaultActivationWindowHours = 720
      const activationTimestamp = new Date(this.newLink.activationDateString).getTime()
      const expirationTimestamp =
        activationTimestamp + defaultActivationWindowHours * 60 * 60 * 1000
      this.newLink.expirationDateString = localDateTimeStringFromUTCdateTimeString(
        new Date(expirationTimestamp).toUTCString()
      )
    }
  },
  mounted() {
    this.newLink.licenseEndDateString = defaultLicenseDateString()
    this.setDefaultExpiration()
    this.$nextTick(() => {
      this.newLink.totalCapacity = this.computeCapacityFromMaxUsers(this.toolkitMaxUsers)
    })
  },
  watch: {
    toolkitMaxUsers: {
      immediate: true,
      handler(val) {
        this.newLink.totalCapacity = this.computeCapacityFromMaxUsers(val)
      }
    }
  }
}
</script>
